export const ALWAYS_REMEMBER_COOKIE = 'alwaysRemember';
export const COUNTRY_PREFERENCE = 'country_preference';
export const ERM_ENABLED = 'ermEnabled';
export const LOCALE = 'locale';
export const REMEMBER_ME = 'remember_me';
export const SSI_DECLINED = 'ssiDeclined';
export const SSI_ENABLED = 'ssiEnabled';
export const VISIT_ID = 'VCO_visitId';
